import { Snackbar, Typography, IconButton, Slide } from '@mui/material';
import SuccessIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/ReportOutlined';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import WarningIcon from '@mui/icons-material/WarningAmberOutlined';
import CancelIcon from '@mui/icons-material/CancelOutlined';

const Alert = ({ type, position, message, open, close }) => (
    <Snackbar
        sx={{
            '& .MuiPaper-root': {
                backgroundColor: type === 'success' ? 'rgb(35, 149, 139)' : type === 'info' ? 'rgb(41, 94, 172)' : 'rgb(189, 30, 52)',
                color: 'white'
            }
        }} anchorOrigin={{ vertical: 'top', horizontal: position }}
        autoHideDuration={5000}
        open={open}
        onClose={close}
        TransitionComponent={Slide}
        TransitionProps={{ direction: position === 'left' ? 'right' : 'left' }}
        transitionDuration={400}
        message={
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                {type === 'success'
                    ? <SuccessIcon />
                    : type === 'info'
                        ? <InfoIcon />
                        : type === 'warning'
                            ? <WarningIcon />
                            : type === 'error'
                                ? <ErrorIcon />
                                : null}
                <Typography variant='h5' component='h5'>{message}</Typography>
            </div>
        } action={
            <IconButton onClick={close}>
                <CancelIcon />
            </IconButton>
        } />
);

export default Alert;